import $ from 'jquery';
import 'chosen-js';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-colpick';
import 'jquery.iframe-transport';
import 'jquery-form';
import 'jquery.scrollto';
import 'summernote';
// blueimp was deprecated/archived by author
import 'blueimp-file-upload';
import 'bootstrap';
import {bindAndHandleMealCategory} from './../../mealCategory';
import '../modules';
import {showConfirmation} from '../modules/modals';
import tempusDominus from "@eonasdan/tempus-dominus";

window.$ = window.jQuery = $;

$(document).ready(function(){Common.init()});

//	This will enable `hover` effects for touchscreens.
document.addEventListener('touchstart', function() {}, true);

var Common =
{
	start: [],
	dialog: null,
	faderTimeout: 0,

	init: function ()
	{
		$(document).ajaxSend(Common.fadeIn);
		$(document).ajaxComplete(Common.fadeOut);
		$(document).ajaxError(Common.handleAjaxError);
		$(document).ajaxSuccess(Common.handleAjaxSuccess);

		$.ajaxSetup({headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}});

		Common.bindHandlers();
		Common.showMessageContainer();
		Common.initFileSelector();
		Common.initListControls();
		Common.initImageZoom();
		Common.disableSubmitButton();
		Common.disableButton();
		Common.bindOptionOpener();
		Common.initRowSelection();
		Common.initInlineActions();
		Common.bindFileSizeCheckToUploadInputs();

        $('form input, form select').on('blur', (e) => {
            const el = e.currentTarget;
            if ('' !== el.value && !el.classList.contains('touched')) {
                el.classList.add('touched');
            }
        });

        $('div.navmenu-left div.list').on('click', Common.toggleNavMenuItem);
		$("input[name='search']").on('keypress', Common.search);
		$('[data-toggle="tooltip"]').tooltip();

        $('select').not('.hidden').not("[data-chosen='disabled']").each(Common.bindChosen);
        $('.wysiwyg').not("[data-summernote='disabled']").each(Common.bindSummernote);

		bindAndHandleMealCategory('#meal-category');
		Common.generalSettingsPage();
		Common.webPagesFilter();
		Common.getPricingPlans();

		if (document.getElementById('datetimepicker')) {
			Common.bindDateTimePicker();
		}
	},

	handleAjaxError: function (e, jqXHR)
	{
		if ((jqXHR['status']) >= 500)
		{
			Common.setMessages('danger', [jqXHR['statusText']]);
		}
		else if (jqXHR['responseJSON'] && jqXHR['responseJSON']['errors'])
		{
			Common.setMessages('danger', jqXHR['responseJSON']['errors']);
		}
	},

	handleAjaxSuccess: function (e, jqXHR)
	{
		if (!jqXHR['responseJSON']) return;
		if (!jqXHR['responseJSON']['message'] && !jqXHR['responseJSON']['messages']) return;

		var type = true === jqXHR['responseJSON']['success'] ? 'success' : 'danger';

		Common.setMessages(type, jqXHR['responseJSON']['message'] ? [jqXHR['responseJSON']['message']] : jqXHR['responseJSON']['messages']);
	},

	bindHandlers: function ($element)
	{
		var handlers = ['scroll', 'redirect', 'modal', 'inject', 'callback'],
			inputs = ['select', "input[type='radio']", "input[type='checkbox']"],
			text = ["input[type='text']", "textarea"],
			$root = $element ? $element : $('div.page-content');

		for (var i in handlers)
		{
			$root.find("button[data-type='" + handlers[i] + "']").off('click.handler').on('click.handler', Common[handlers[i]]);
			$root.find("button[data-fade='true']").off('click.fade').on('click.fade', Common.fadeIn);
		}

		for (i in inputs)
		{
			$root.find(inputs[i] + "[data-type='callback']").off('change.handler').on('change.handler', Common.callback);
		}

		for (i in text)
		{
			$root.find(text[i] + "[data-type='callback']").off('keyup.handler').on('keyup.handler', Common.callback);
			$root.find(text[i] + "[data-type='autocomplete']").off('keyup.handler').on('keyup.handler', Common.autocomplete);
		}

		$root.find("form[data-type='callback']").off('submit.handler').on('submit.handler', Common.callback);

		const searchField = document.getElementById('search-input');
		if (null !== searchField) {
			document.getElementById('clear-search').addEventListener('click', (e) => {
				e.preventDefault();
				const url = new URL(window.location)
				url.searchParams.delete('filter[search]');
				url.searchParams.set('page', '1');
				window.location.replace(url.toString());
			});
			searchField.addEventListener('keyup', (e) => {
				if ('Enter' === e.key) {
                    // `page` here is required to prevent from redirections
					window.location.search = new URLSearchParams([['filter[search]', e.target.value], ['page', 1]]);
				}
				e.preventDefault();
			});
		}
	},

	bindSummernote: function (index, elem, videoLibraryButton = false)
	{
		const VideoLibraryButton = function () {
			const ui = $.summernote.ui;

			const button = ui.button({
				contents: '<i class="fa fa-play"/>',
				tooltip: 'Video Library',
				click: function () {
					window.open('/website/video', '_blank').focus();
				}
			});

			return button.render();
		};

		let toolbar = [
			['control', ["undo", "redo"]],
			['style', ["bold", "italic", "underline"]],
			['fontsize', ['fontsize']],
			['list', ["ol", "ul"]],
			['insert', ["hr", "link"]],
		];

		if (videoLibraryButton) {
			toolbar.push(['misc', ["codeview", "videoLibrary"]]);
		} else {
			toolbar.push(['misc', ["codeview"]]);
		}

        const isRunningInsideModal = document.body.classList.contains('modal-open');

		$(elem).summernote({
		    dialogsInBody: true,
			useProtocol: true,
			defaultProtocol: "https://",
			toolbar: toolbar,
			callbacks: {
				onPaste: function(e) {
					const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
					e.preventDefault();
					setTimeout( function(){
						document.execCommand( 'insertText', false, bufferText );
					}, 1 );
				},
				onBlurCodeview: function(text) {
					elem.value = text;
				},
                /**
                 * Fixes a problem when summernote is running inside a modal, opens it's own modal dialog (for example
                 * the link dialog) and when it is closed, the main modal can not be scrolled any more.
                 */
                onDialogShown: function(contents, $editable) {
                    if (!isRunningInsideModal) {
                        return;
                    }
                    console.debug("Setting up a fix for main modal not scrolling after any summernote dialog is opened");

                    // Since there is no onDialogHidden hook
                    // Timer will check if any summernote modal is opened
                    // and fix the main modal if it is already closed
                    window.summernoteModalInterval = setInterval(() => {
                        const summernoteModal = document.querySelector(".note-modal.in");
                        if (!summernoteModal) {
                            if (!document.body.classList.contains('modal-open')) {
                                console.debug("Applying fix for main modal");
                                document.body.classList.add("modal-open");
                            }
                            clearInterval(window.summernoteModalInterval);
                        }
                    }, 500);
                },
                onChange: function(contents, $editable) {
                    const fixedContents = contents.replace(/mailto:\/\//g, 'mailto:');
                    if (contents !== fixedContents) {
                        $(elem).summernote('code', fixedContents);
                    }
                },
            },
			buttons: {
				videoLibrary: VideoLibraryButton
			},
            codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|blink)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|t(?:itle|extarea)|xml)[^>]*?>/gi,
            codeviewIframeWhitelistSrc: ['drive.google.com', 'embed.typeform.com'],
		});

        $(elem).closest('form').on('submit', function() {
            if ($(elem).summernote('codeview.isActivated')) {
                const codeContent = $(elem).next('.note-editor').find('.note-codable').val();
                $(elem).summernote('code', codeContent);
            }
        });
	},

	bindChosen: function (index, elem, options = {})
	{
		const
			$select = $(elem),
			maxOptions = $select.attr('data-max-selections'),
			searchThreshold = $select.attr('data-search-threshold');

		let chosenOptions = Object.assign({
            allow_single_deselect: true,
            placeholder_text_multiple: ''
        }, options);

		if (maxOptions) {
			chosenOptions.max_selected_options = maxOptions;
		}

		if (searchThreshold) {
			chosenOptions.disable_search_threshold = searchThreshold;
		}

		$select.chosen(chosenOptions);
	},

	showMessageContainer: function ($elem)
	{
		var $container = $elem ? $elem : $('div.message-container.active');

		var closeMessageContainer = function ()
		{
			$container.removeClass('active').fadeOut();
		};

		$container.addClass('active').fadeIn();
		$container.find('button.close').one('click', closeMessageContainer);

		if (true !== $container.hasClass('bg-danger'))
		{
			setTimeout(closeMessageContainer, 3000);
		}
	},

	closeMessageContainer: () => {
		$('div.message-container.active').removeClass('active').fadeOut();
	},

	initFileSelector: function ()
	{
		$('.file-selector').change(function(e)
		{
			var $elem = $(e.currentTarget),
				names = '<br/>',
				$files = $elem.get(0).files;

            if ($files.length === 0) {
                $elem.siblings('.file-list').html('').addClass('hidden');
                return;
            }
            $elem.siblings('.file-list').removeClass('hidden');

			for (var i = 0; i < $files.length; i++)
			{
				names = names + $files.item(i).name + '<br/>';
			}

			$elem.siblings('.file-list').html(names);
		});
	},

	initListControls: function ()
	{
		var makeListSortable = function ($list)
		{
			$list.sortable({
				axis: 'y',
				containment: "parent",
				handle: ".sortable-handle",
				items: $list.find('.sortable-item')
			});
		};

		const addButtonCheckState = ($item) => {
			if (typeof $item.data('max-items') !== 'number') {
				return;
			}

			$item.find('button.add-list-item').prop({
				disabled: $item.children('.list-item').length === ($item.data('max-items') + 1)
			});
		};

		$('[data-type="list"][data-max-items]').each((i, item) => {
			addButtonCheckState($(item));
		});

		$('button.add-list-item').click(function (e)
		{
			e.preventDefault();

			var $item = $(e.target).closest(".list-item"),
				$input = $item.find('input[type="text"]'),
				$list = $item.closest("div.sortable-list");

			if ($input.val())
			{
				var $clone = $item.clone(),
					$newInput = $clone.find('input[type="text"]');
				$clone
					.removeAttr('data-dummy-row');
				$clone.find('[data-toggle="tooltip"]').tooltip('destroy');

				$clone
					.find('[data-show-on-insert].hidden')
					.removeClass('hidden')
					.removeAttr('data-show-on-insert');

				Common.bindChosen(0, $clone.find('select[data-chosen="disabled"]'));

				$clone.find('button.add-list-item').tooltip('destroy').remove();
				$clone.find('button.remove-list-item').removeClass('hidden');
				$clone.find('.sortable-handle').removeClass('hidden');
				$clone.addClass('sortable-item');

				$newInput.attr('name', $input.attr('data-name'));

				$input.val('').focus();
				$clone.insertBefore($item);
				$clone.find('[data-toggle="tooltip"]').tooltip();
				$item.find('[data-toggle="tooltip"]').tooltip('hide');

				makeListSortable($list);
				addButtonCheckState($item.parent('[data-type="list"]'));
			}
			else
			{
				$input.focus();
			}
		});

        $('button.add-list-item-habits').click(function (e)
		{
			e.preventDefault();

            const $item = $(e.target).closest(".list-item"),
                $input = $item.find('input[type="text"]'),
                $list = $item.closest("div.sortable-list");
            if ($input.val() == null || $input.val().trim() === '' ) {
                return;
            }
            const inputs = $('.habits-input').map(function() {
                return this.value;
            }).get();
            var uniqueValues = new Set(inputs);
            var isDuplicate = false;
            if (uniqueValues.size < inputs.length) {
                isDuplicate = true;
            }

            if (isDuplicate) {
                alert('Please remove duplicated habit name');
                return;
            }

            if ($input.val())
			{
				var $clone = $item.clone(),
					$newInput = $clone.find('input[type="text"]');
				$clone
					.removeAttr('data-dummy-row');
				$clone.find('[data-toggle="tooltip"]').tooltip('destroy');

				$clone
					.find('[data-show-on-insert].hidden')
					.removeClass('hidden')
					.removeAttr('data-show-on-insert');

				Common.bindChosen(0, $clone.find('select[data-chosen="disabled"]'));

				$clone.find('button.add-list-item').tooltip('destroy').remove();
				$clone.find('button.remove-list-item').removeClass('hidden');
				$clone.find('.sortable-handle').removeClass('hidden');
				$clone.addClass('sortable-item');

				$newInput.attr('name', $input.attr('data-name'));

				$input.val('').focus();
				$clone.insertBefore($item);

				$clone.find('[data-toggle="tooltip"]').tooltip();
				$item.find('[data-toggle="tooltip"]').tooltip('hide');

				makeListSortable($list);
				addButtonCheckState($item.parent('[data-type="list"]'));
			}
			else
			{
				$input.focus();
			}
		});

		$(document).on('click','button.remove-list-item', function (e)
		{
			e.preventDefault();

			const $list = $(e.target).closest('.list-item');
			const $parent = $list.parent();
			$(e.currentTarget).tooltip('destroy');
			$list.remove();
			addButtonCheckState($parent);
		});

		makeListSortable($("div.sortable-list"));
	},

	initImageZoom: function (e)
	{
		$("img[data-zoom]").on('click', function (e) {
			var big_image = $(this).attr('data-zoom'),
				$img = $('<img />', {
					src: big_image,
					style: "max-width: 90vw; max-height: 90vh"
				}).addClass('zoomed_img');

			$('<div />').append($img).dialog({
				modal: true,
				width: "auto",
                height: "auto",
				resizable: false,
				position: { my: "center", at: "center", of: window },
				show: { effect: "fade", duration: 500 },
				hide: { effect: "fade", duration: 500 },
				close: function() {
					$('.ui-dialog').remove();
				}
			});

			$(".ui-dialog-titlebar").hide();

			$(".ui-widget-overlay, .zoomed_img").on("click", function(){
				$(".ui-dialog-titlebar-close").trigger('click');
			});
		});
	},

	toggleNavMenuItem: function (e)
	{
		var $list = $(e.target).closest('div.list');

		if ($list.hasClass('active')) return;

		$('div.list.active').removeClass('active');
		$list.addClass('active');
	},

	scroll: function (e)
	{
		var $elem = $(e.target).closest('button'),
			to = $elem.attr('data-scroll');

		$.scrollTo(to, 500);
	},

	redirect: function (e)
	{
		var $elem = $(e.target).closest('button'),
			url = $elem.attr('data-url'),
			target = $elem.attr('data-target');

		if (e.which == 2) target = 'blank';

		switch (target)
		{
			case 'blank':
			case '_blank':
				window.open(url);
				break;

			default:
				window.location.href = url;
		}
	},

	modal: function (e)
	{
		var $elem = $(e.target).closest('button'),
			$dialog = $('div.modal'),
			url = $elem.attr('data-url');

		$dialog.remove();

		var openDialog = function (data)
		{
			$('div.ajax').html(data.html);

			$dialog = $('div.modal');
			$dialog.find("button.btn-action[type!='submit']").on('click', submitData);
			$dialog.modal();

			Common.bindHandlers($dialog);
		};

		var submitData = function ()
		{
			var type = $dialog.attr('data-submit-type');

			if ('callback' == type)
			{
				Common[$dialog.attr('data-callback')].call($dialog);
				return;
			}

			var url = $dialog.attr('data-url');

			if ('redirect' == type)
			{
				closeDialog({'success': true});
				window.location.href = url;
				return;
			}

			$.ajax({
				'url': url,
				'type': 'POST',
				'data': $dialog.find('form').serializeArray(),
				'success': closeDialog
			});
		};

		var closeDialog = function (data)
		{
			if (!data.success) return;

			var callback = $dialog.attr('data-close-callback'),
				hideModal = true;

			if (callback) hideModal = Common[callback].call($dialog, data);

			if (false !== hideModal) $dialog.modal('hide');
		};

		$.ajax({
			'url': url,
			'type': 'GET',
			'success': openDialog
		});
	},

	inject: function (e)
	{
		var $elem = $(e.target).closest('button'),
			url = $elem.attr('data-url'),
			container = $elem.attr('data-container');

		var injectHTML = function (data)
		{
			$(container).html(data.html);
		};

		$.ajax({
			'url': url,
			'type': 'GET',
			'success': injectHTML
		});
	},

	callback: function (e)
	{
		var $elem = $(e.target).closest("[data-type='callback']"),
			callback = $elem.attr('data-callback');

		Common[callback].call($elem, e);
	},

    refresh: function ()
    {
        location.reload();
    },

	search: function (e)
	{
		if (13 != e.keyCode) return;

		var $elem = $(e.target);

		window.location.href = $elem.attr('data-url') + '/' + encodeURI($elem.val());
	},

	autocomplete: function (e)
	{
		var $elem = $(e.target),
			url = $elem.attr('data-url'),
			fields = [],
			data = {json: true};

		if (e.target.hasAttribute('data-autocomplete-field'))
		{
			fields = [$elem.attr('data-autocomplete-field')];
		}
		else if (e.target.hasAttribute('data-autocomplete-fields'))
		{
			fields = JSON.parse($elem.attr('data-autocomplete-fields'));
		}

		var getSource = function (request, response)
		{
			for (var i in fields)
			{
				data[fields[i]] = {operand: '~%', text: request.term};
			}

			$.ajax({
				'url': url,
				'type': 'GET',
				'data': data,
				'success': function (data)
				{
					response(data);
				},
				'error': function (data)
				{
					response([]);
				}
			});
		};

		$elem.autocomplete({
			source: getSource,
			minLength: 2,
			messages: {
				noResults: '',
				results: function() {}
			}
		});
	},

	loadMoreResults: function (e)
	{
		var $elem = this,
			next = $elem.attr('data-next');

		var showMoreResults = function (data)
		{
			$('.page-content table.list tr:last').after(data.html);

			Common.bindHandlers();

			data.next ? $elem.attr('data-next', data.next).blur() : $elem.prop('disabled', true);
		};

		$.ajax({
			'url': window.location.href,
			'type': 'GET',
			'data': {page: next},
			'success': showMoreResults
		});
	},

	setMessages: function (type, messages)
	{
		var $container = $('div.message-container.bg-' + type),
			$active = $('div.message-container.active');

		var onComplete = function ()
		{
			$container.find('div').remove();

			for (var i in messages)
			{
				$container.append($('<div>').html(messages[i]));
			}

			Common.showMessageContainer($container);
		};

		if ($active.length)
		{
			$active.fadeOut({complete: onComplete});
		}
		else
		{
			onComplete();
		}
	},

	toggleSearch: function (e)
	{
		var $button = this,
			$searchContainer = $('div.page-search');

		if ($button.hasClass('active'))
		{
			$button.removeClass('active').blur();
			$searchContainer.hide('fast');
		}
		else
		{
			$button.addClass('active');
			$searchContainer.show('fast', function(){ $searchContainer.find('input').select() });
		}
	},

	toggleFilter: function (e)
	{
		//TODO
	},

	updateRecord: function (data)
	{
		var $element = $("tr[data-id=" + data['element']['id'] + "]"),
			$replacement = $(data['element']['html']);

		$element.before($replacement);
		$element.remove();

		Common.bindHandlers($replacement);
	},

	removeElementByID: function (data)
	{
		$("[data-element='" + data.element +"'][data-id='" + data.id + "']").remove();
	},

	getInjectContent: function (e)
	{
		var $elem = $(e.target).closest('button'),
			$container = $($elem.attr('data-append-container')),	//where the HTML will be injected
			after_function = $elem.attr('data-after-function'),		//name of function, executed after injecting
			container_elements = 0,									//how many elements are in the container
			url = $elem.attr('data-url'),							//url for the AJAX request
			id = $($elem.attr('data-id-source')).val(),				//id of the element for which we create the HTML
			additional_data = $elem.attr('data-additional'),		//some additional data (optional)
			add_count = $elem.attr('data-add-count'),				//do we need to pass the count of the main elements in the container to the server (optional -> 1 for YES)
			highest_element_number = 0;								//highest element number -> used to avoid element duplication

		if (typeof id != 'undefined' && id > 0) {
			url = url + '/' + id;
		}

		if (typeof additional_data != 'undefined' && additional_data != '') {
			url = url + '/' + additional_data;
		}

		if (add_count == 1) {
			container_elements = $container.get(0).childElementCount;
			url = url + '/' + container_elements;

			$.each($container.children(), function(){
				if ($(this).attr('data-element-count') > highest_element_number) {
					highest_element_number = $(this).attr('data-element-count');
				}
			});

			url = url + '/' + highest_element_number;
		}

		var injectHTML = function (data)
		{
			let $element = $(data.html);

			$container.append($element);
			Common.bindHandlers($element);
			if (typeof after_function != 'undefined' && after_function != '') window[after_function]();
		};

		$.ajax({
			'url': url,
			'type': 'GET',
			'success': injectHTML
		});
	},

	removeContent: function (e) {
		var $elem = $(e.target).closest('button');

		$elem.closest('.' + $elem.attr('data-remove')).remove();
	},

	deleteImage: function (e)
	{
		var clone = $("input[name='clone']").val(),
			$deleteButton = $(e.target).closest('button'),
			$container = $deleteButton.parents('div.existing-image'),
			$undoButton = $container.find('button.btn-undo'),
			$image = $container.find('img'),
			$hidden = $container.find("input[name*='" + (1 == clone ? "clone_image" : "delete_image") + "']");

		$image.hide();
		$deleteButton.addClass('hidden');
		$undoButton.removeClass('hidden');
		$hidden.val(clone == 1 ? 0 : 1);
	},

	restoreImage: function (e)
	{
		var clone = $("input[name='clone']").val(),
			$undoButton = $(e.target).closest('button'),
			$container = $undoButton.parents('div.existing-image'),
			$deleteButton = $container.find('button.btn-delete'),
			$image = $container.find('img'),
			$hidden = $container.find("input[name='" + (1 == clone ? "clone_image" : "delete_image") + "']");

		$image.show();
		$deleteButton.removeClass('hidden');
		$undoButton.addClass('hidden');
		$hidden.val(clone == 1 ? $hidden.attr('data-id') : 0);
	},

	deleteImageMulti: function (e)
	{
		var clone = $("input[name='clone']").val(),
			$deleteButton = $(e.target).closest('button'),
			$container = $deleteButton.parents('div.existing-image'),
			$undoButton = $container.find('button.btn-undo'),
			$confirmationMsg = $container.find('div.delete-confirmation-msg'),
			$image = $container.find('img'),
			$hidden = $container.find("input[name='" + (1 == clone ? "clone_images[]" : "delete_images[]") + "']");

		$image.hide();
		$confirmationMsg.removeClass('hidden');
		$deleteButton.addClass('hidden');
		$undoButton.removeClass('hidden');
		$hidden.attr('disabled', (clone == 1 ? true : false));
	},

	restoreImageMulti: function (e)
	{
		var clone = $("input[name='clone']").val(),
			$undoButton = $(e.target).closest('button'),
			$container = $undoButton.parents('div.existing-image'),
			$deleteButton = $container.find('button.btn-delete'),
			$confirmationMsg = $container.find('div.delete-confirmation-msg'),
			$image = $container.find('img'),
			$hidden = $container.find("input[name='" + (1 == clone ? "clone_images[]" : "delete_images[]") + "']");

		$image.show();
		$confirmationMsg.addClass('hidden');
		$deleteButton.removeClass('hidden');
		$undoButton.addClass('hidden');
		$hidden.attr('disabled', (clone == 1 ? false : true));
	},

	deleteFile: function (e)
	{
		var $deleteButton = $(e.target).closest('button'),
			$container = $deleteButton.parents('div.existing-file'),
			$undoButton = $container.find('button.btn-undo'),
			$file = $container.find('a'),
			$hidden = $container.find("input[type='hidden']");

		$file.hide();
		$deleteButton.addClass('hidden');
		$undoButton.removeClass('hidden');
		$hidden.val(1);
	},

	restoreFile: function (e)
	{
		var $undoButton = $(e.target).closest('button'),
			$container = $undoButton.parents('div.existing-file'),
			$deleteButton = $container.find('button.btn-delete'),
			$file = $container.find('a'),
			$hidden = $container.find("input[name='delete-file']");

		$file.show();
		$deleteButton.removeClass('hidden');
		$undoButton.addClass('hidden');
		$hidden.val(0);
	},

	addIngredient: function (e)
	{
		var $addButton = $(e.target).closest('button'),
			$container = $addButton.parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$select = $container.find('select'),
			$itemSettings = $container.find('.item-settings');

		if (0 == $select.val())
		{
			$container.find('.chosen-container').addClass('chosen-container-active');
			$addButton.blur();
			return;
		}

		$select.chosen('destroy');

		var substitute = $addButton.attr('data-ingredient') == 'substitute',
			$clone = $container.clone(true, true);

		if (substitute)
		{
			$container.addClass('ingredient-substitutable');

			$clone.addClass('ingredient-substitute').removeClass('ingredient-substitutable');
			$clone.find('.btn-link').addClass('hidden');
			$clone.find('.item-or').removeClass('hidden');
			$clone.find('select').on('change', Common.setIngredientUnit).val($select.val()).trigger('change');
		}
		else
		{
			$addButton.addClass('hidden');
		}

		$deleteButton.removeClass('hidden');
		$select.attr('name', $select.attr('data-name')).chosen();
		$select.on('change', Common.setIngredientUnit).trigger('change');

		$itemSettings.removeClass('hidden');

		if (substitute) while ($container)
		{{
			var $next = $container.next();

			if (!$next.hasClass('ingredient-substitute')) break;

			$container = $next;
		}}

		$container.after($clone);

		$clone.find('select').chosen();
	},

	setIngredientUnit: function (e)
	{
		var $select = $(e.target),
			$container = $select.parents('div.list-item'),
			selected = $select.val(),
			scalable = ingredients[selected]['scalable'],
			$itemSettings = $container.find('.item-settings'),
			$min  = $itemSettings.find("[data-amount='min']"),
			$base = $itemSettings.find("[data-amount='base']"),
			$max  = $itemSettings.find("[data-amount='max']"),
			$round = $itemSettings.find("[data-amount='round']");

		$base.attr('name', $base.attr('data-name').replace('%s', selected));

		$min.attr('name', $min.attr('data-name').replace('%s', selected));
		$max.attr('name', $max.attr('data-name').replace('%s', selected));
		$round.attr('name', $round.attr('data-name').replace('%s', selected));

		if (!scalable)
		{
			$base[0].addEventListener('keyup', (e) => {
				$min.val(e.target.value);
				$max.val(e.target.value);
			});
			$min.attr('readonly', true);
			$max.attr('readonly', true);
			$round.attr('readonly', true).val('0');
		}

		$itemSettings.find('.item-unit-name').text(ingredients[selected]['unit']);
	},

	deleteIngredient: function (e)
	{
		var $container = $(e.target).closest('div.list-item.ingredient'),
			substitutable = $container.hasClass('ingredient-substitutable'),
			substitute = $container.hasClass('ingredient-substitute'),
			$ingredient,
			$substitute;

		if (substitutable)
		{
			$ingredient = $container.next();

			while ($ingredient)
			{
				if (!$ingredient.hasClass('ingredient-substitute')) break;

				$substitute = $ingredient;
				$ingredient = $ingredient.next();

				$substitute.remove();
			}
		}

		if (substitute)
		{
			var $prev = $container.prev(),
				$next = $container.next();

			if (!$next.hasClass('ingredient-substitute')) $prev.removeClass('ingredient-substitutable');
		}

		$container.remove();
	},

	createSubstituteList: function (e)
	{
		e.preventDefault();

		var substitutable,
			$target = $(e.target),
			$subContainer = $('div.substitute-inputs'),
			$forContainer = $('div.for-inputs');

		$('div.list-item.ingredient').each(function()
		{
			var $item = $(this),
				selected = $item.find('select').val();

			if ($item.hasClass('ingredient-substitutable'))
			{
				substitutable = selected;
			}
			else if ($item.hasClass('ingredient-substitute'))
			{
				var $substitute = $("input[name='substitutes_placeholder']"),
					$for = $("input[name='for_placeholder']"),
					$subClone = $substitute.clone(),
					$forClone = $for.clone();

				$subClone.val(selected);
				$subClone.attr('name', $subClone.attr('data-name'));

				$forClone.val(substitutable);
				$forClone.attr('name', $forClone.attr('data-name'));

				$subContainer.append($subClone);
				$forContainer.append($forClone);
			}
		});

		var $form = $target.closest('form');

		if ('draft' == $target.attr('name'))
		{
			$form.find("input[name='draft']").val(1);
		}
	},

	addMuscle: function (e)
	{
		var $addButton = $(e.target).closest('button'),
			$container = $addButton.parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$select = $container.find('select'),
			index = $container.parents('div.list').find('div.list-item').length - 1;

		$select.not('.hidden').chosen('destroy');

		var $clone = $container.clone(true, true);

		$addButton.addClass('hidden');
		$deleteButton.removeClass('hidden');

		$container.find("[data-type='item-property']").each(function ()
		{
			var $input = $(this);

			$input.removeClass('hidden').attr('name', $input.attr('data-name').replace('%s', index));
		});

		$select.each(function ()
		{
			var $elem = $(this);

			$elem.attr('name', $elem.attr('data-name').replace('%s', index)).chosen();
		});

		$container.after($clone);

		$clone.find('select').not('.hidden').chosen();
	},

	addSponsoredItem: function (e)
	{
		var $addButton = $(e.target).closest('button'),
			$container = $addButton.parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$select = $container.find('select'),
			$input = $container.find('input'),
			$hidden = $("input[name='sponsored_placeholder']"),
			$sponsored = $("input[name='sponsored[]']");

		if (!$input.val())
		{
			$input.focus();
			return;
		}

		if (!$select.val())
		{
			$container.find('.chosen-container').addClass('chosen-container-active');
			$addButton.blur();
			return;
		}

		$select.chosen('destroy');

		var $clone = $container.clone(true, true),
			id = $sponsored.length ? parseInt($sponsored.last().val()) + 1 : 0;

		$addButton.addClass('hidden');
		$deleteButton.removeClass('hidden');
		$input.attr('name', 'sponsored_' + id + '_name');
		$select.attr('name', 'sponsored_' + id + '_regions[]').chosen();

		$container.after($clone);

		$clone.find('input').val('');
		$clone.find('select').chosen();

		$clone = $hidden.clone();
		$clone.attr('name', $hidden.attr('data-name')).val(id);

		$clone.insertAfter($sponsored.length ? $sponsored.last() : $hidden);
	},

	deleteSponsoredItem: function (e)
	{
		$(e.target).closest('div.list-item').remove();
	},

	addListItem: function (e)
	{
		var $addButton = $(e.target).closest('button'),
			$container = $addButton.closest('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$select = $container.find('select'),
			$input = $container.find('input');

		if (0 == $select.val())
		{
			$container.find('.chosen-container').addClass('chosen-container-active');
			$addButton.blur();
			return;
		}

		$select.chosen('destroy');

		var $clone = $container.clone(true, true);

		$addButton.addClass('hidden');
		$deleteButton.removeClass('hidden');

		$select.each(function()
		{
			var $elem = $(this);

			$elem.attr('name', $elem.attr('data-name')).chosen();
		});

		$input.each(function()
		{
			var $elem = $(this);

			$elem.attr('name', $elem.attr('data-name'));
		});

		$container.after($clone);

		$clone.find('input').val('');
		$clone.find('select').chosen();
	},

	addProductItem: function (e)
	{
		var $addButton = $(e.target).closest('button'),
			$container = $addButton.parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$select = $container.find('select'),
			$period = $container.find('.period'),
			$update = $container.find('.update'),
			$periodField = $period.find('.period-field'),
			$defaultRadio = $period.find('.default-check'),
			$defaultRadioLabel = $period.find('.default-check-label');

		if (0 == $select.val())
		{
			$container.find('.chosen-container').addClass('chosen-container-active');
			$addButton.blur();
			return;
		}

		$select.chosen('destroy');

		var $clone = $container.clone(true, true);

		$addButton.addClass('hidden');
		$deleteButton.removeClass('hidden');
		$period.removeClass('hidden');
		$update.removeClass('hidden');
		const $randomName = 'update-' . concat(String(1000 + Math.trunc(Math.random() * 1000)));
		$update.children('input[name="program_update_cbx"]').attr('id', $randomName);
		$update.children('label').attr('for', $randomName);
		$select.attr('name', $select.attr('data-name')).chosen();
		$periodField.attr('name', $periodField.attr('data-name'));
		$defaultRadio.attr('id', 'is_default_page_' + $select.val());
		$defaultRadio.attr('value', $select.val());
		$defaultRadioLabel.attr('for', 'is_default_page_' + $select.val());
		$container.after($clone);

		$clone.find('select').chosen();
	},

	addPageItem: function (e)
	{
		var $container = $(e.currentTarget).parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			$sequence = $container.find('input.sequence'),
			$select = $container.find('select');

		$select.chosen('destroy');

		var $clone = $container.clone(true, true);

		$deleteButton.removeClass('hidden');
        const countPagesAdded = $('#product-pages-list select:not(:disabled)').length;
        $select.prop('disabled', false).chosen();
		$select.attr('name', $select.attr('name').replace('__PLACEHOLDER__ID__', countPagesAdded+1));
        $sequence.parent('div').removeClass('hidden');
        $sequence.prop('disabled', false);
        $sequence.attr('name', $sequence.attr('name').replace('__PLACEHOLDER__ID__', countPagesAdded+1));
		$container.after($clone);

		$clone.find('select').chosen();
        e.currentTarget.remove();
    },

    addHabitItem: function (e)
	{
		const $addButton = $(e.target).closest('button'),
			$container = $addButton.parents('div.list-item'),
			$deleteButton = $container.find('button.btn-delete'),
			// $period = $container.find('.period'),
			$update = $container.find('.update')
			// $periodField = $period.find('.period-field')
        ;

		let $clone = $container.clone(true, true);
        console.log('cloned');
		$addButton.addClass('hidden');
		$deleteButton.removeClass('hidden');
		// $period.removeClass('hidden');
		$update.removeClass('hidden');
		// const $randomName = 'update-' . concat(String(1000 + Math.trunc(Math.random() * 1000)));
		// $update.children('input[name="habit_update_cbx"]').attr('id', $randomName);
		// $update.children('label').attr('for', $randomName);
		// $periodField.attr('name', $periodField.attr('data-name'));
		$container.after($clone);
	},

	deleteListItem: function (e)
	{
		$(e.target).closest('div.list-item').remove();
	},

	switchMeal: function (e)
	{
		var $select = $(e.target),
			$container = $('.plan-container'),
			system, gmid, day, tid;

		if ($container.hasClass('meal-plan'))
		{
			system = $container.attr('data-system');
			gmid = $select.parents('.meal').attr('data-id');
			day = null;
			tid = null;
		}
		else
		{
			var $meal = $select.closest('.meal-container');

			system = $('select#system').val();
			gmid = null;
			day = $meal.attr('data-day');
			tid = $meal.attr('data-tid');
		}

		var onSuccess = function (data)
		{
			if (!data.success) return;

			var $mealContainer = $select.parents('.meal-container'),
				$list = $mealContainer.find('.recipe-list');

			$list.html(data.html);

			Common.bindHandlers($list);

			var $inputs = $list.find('div.quantity > input');

			$inputs.on('keyup', Common.checkIngredientQuantity);
			$inputs.first().trigger('keyup');

			$mealContainer.find('.meal.container-fluid span.unit.hidden').removeClass('hidden');

			const
				$container = $mealContainer.parent().find('.container-fluid'),
				$energy = $container.find('.energy'),
				energyMinValue = $energy.data('minvalue'),
				energyMaxValue = $energy.data('maxvalue'),
				proteinMinValue = $container.find('.protein').data('minvalue'),
				fatMinValue = $container.find('.fat').data('minvalue'),
				$meal = $mealContainer.find('.meal'),
				$rowEnergy = $meal.find('.energy'),
				$rowProtein = $meal.find('.protein'),
				$rowFat = $meal.find('.fat'),
				rowEnergy = parseInt($rowEnergy.text()),
				rowProtein = parseInt($rowProtein.text()),
				rowFat = parseInt($rowFat.text()),
				isCaloriesOK = rowEnergy >= energyMinValue && rowEnergy <= energyMaxValue,
				isProteinOK = rowProtein >= proteinMinValue,
				isFatOK = rowFat >= fatMinValue;

			$rowEnergy.parent()
				.toggleClass('text-success', isCaloriesOK)
				.toggleClass('text-danger', !isCaloriesOK);
			$rowProtein.parent()
				.toggleClass('text-success', isProteinOK)
				.toggleClass('text-danger', !isProteinOK);
			$rowFat.parent()
				.toggleClass('text-success', isFatOK)
				.toggleClass('text-danger', !isFatOK);

			const
				$planManagerForm = $('#plan_manager_form');

			$planManagerForm
				.find(`input[name="replace-gen-meals-ids[]"][value=${gmid}]`).remove();
			$planManagerForm.append(
				$('<input />')
					.attr('type', 'hidden')
					.attr('name', 'replace-gen-meals-ids[]')
					.val(gmid)
			);

			$('#plan_manager_form_submit').attr('disabled', false);
		};

		$.ajax({
			'url': $select.attr('data-url'),
			'type': 'GET',
			'data': {'mid': $select.val(), 'gmid': gmid, 'day': day, 'tid': tid, 'system': system},
			'beforeSend': function() {
				$('#plan_manager_form_submit').attr('disabled', true);
			},
			'success': onSuccess,
			'error': function() {
				Common.setMessages('danger', ['Something went wrong during request to the server. You can refresh the page and try again. If error persists, please contact support']);
			}
		});
	},

	checkIngredientQuantity: function (e)
	{
		var $input = $(this),
			quantity = parseFloat($input.val());

		if (isNaN(quantity)) return;

		var $container = $input.closest('.container-fluid');

		$container.find('.energy').text(Math.round(quantity * $input.attr('data-energy')));
		$container.find('.protein').text(Math.round(quantity * $input.attr('data-protein')));
		$container.find('.fat').text(Math.round(quantity * $input.attr('data-fat')));
		$container.find('.carbohydrates').text(Math.round(quantity * $input.attr('data-carbohydrates')));

		Common.updateNutritionalValues($input);
	},

	updateNutritionalValues: function ($context)
	{
		var $recipe = $context.closest('div.recipe-container'),
			energy = 0,
			protein = 0,
			fat = 0,
			carbohydrates = 0;

		var updateContainerData = function ($parent, type, energy, protein, fat, carbohydrates)
		{
			const $container = $parent.find('div.' + type + '.container-fluid');

            if (type === 'type') {
                $container.find('.energy').attr('data-value', Math.round(energy));
                $container.find('.protein').attr('data-value', Math.round(protein));
                $container.find('.fat').attr('data-value', Math.round(fat));
                $container.find('.carbohydrates').attr('data-value', Math.round(carbohydrates));
            } else {
                $container.find('.energy').text(Math.round(energy));
                $container.find('.protein').text(Math.round(protein));
                $container.find('.fat').text(Math.round(fat));
                $container.find('.carbohydrates').text(Math.round(carbohydrates));
            }

			if (type === 'meal') {
				const $containerMealType = $parent.parent().find('div.type.container-fluid');
				$container.find('.can-decorate').each(function (idx, item) {
					const $item = $(item);
					const $span = $item.find('span');
					$item.removeClass("text-success");
					$item.removeClass("text-danger");
					if (
						($span.hasClass('energy') && energy >= $containerMealType.find('.energy').attr('data-minValue') && energy <= $containerMealType.find('.energy').attr('data-maxValue')) ||
						($span.hasClass('protein') && protein >= $containerMealType.find('.protein').attr('data-minValue')) ||
						($span.hasClass('fat') && fat >= $containerMealType.find('.fat').attr('data-minValue'))
					) {
						$item.addClass("text-success");
					} else {
						$item.addClass("text-danger");
					}
				});
			}

            // When editing ingredient quantities if any of them makes calories out of range, update day totals colors
            if (type === 'totals') {
                const isEnergyWithinRange = energy >= $container.data('energy-min') && energy <= $container.data('energy-max');

                $container.find('.can-decorate').each(function (idx, item) {
                    if (isEnergyWithinRange) {
                        item.classList.contains('text-danger') && item.classList.remove('text-danger');
                        item.classList.contains('text-success') || item.classList.add('text-success');
                    } else {
                        item.classList.contains('text-success') && item.classList.remove('text-success');
                        item.classList.contains('text-danger') || item.classList.add('text-danger');
                    }
                });

            }
		};

		$recipe.find('div.ingredient div.quantity > input').each(function()
		{
			var $input = $(this);

			energy += $input.val() * $input.attr('data-energy');
			protein += $input.val() * $input.attr('data-protein');
			fat += $input.val() * $input.attr('data-fat');
			carbohydrates += $input.val() * $input.attr('data-carbohydrates');
		});

		updateContainerData($recipe, 'recipe', energy, protein, fat, carbohydrates);

		var $meal = $recipe.closest('div.meal-container');

		energy = protein = fat = carbohydrates = 0;

		$meal.find('div.recipe.container-fluid').each(function()
		{
			var $element = $(this);

            energy += parseInt($element.find('.energy').text(), 10);
            protein += parseInt($element.find('.protein').text(), 10);
            fat += parseInt($element.find('.fat').text(), 10);
            carbohydrates += parseInt($element.find('.carbohydrates').text(), 10);
		});

		updateContainerData($meal, 'meal', energy, protein, fat, carbohydrates);
		updateContainerData($meal.closest('div.type-container'), 'type', energy, protein, fat, carbohydrates);

		var $day = $meal.closest('div.day-container');

		energy = protein = fat = carbohydrates = 0;

		$day.find('div.type.container-fluid').each(function()
		{
			var $element = $(this);

            energy += parseInt($element.find('.energy').attr('data-value'), 10);
            protein += parseInt($element.find('.protein').attr('data-value'), 10);
            fat += parseInt($element.find('.fat').attr('data-value'), 10);
            carbohydrates += parseInt($element.find('.carbohydrates').attr('data-value'), 10);
		});

		updateContainerData($day, 'totals', energy, protein, fat, carbohydrates);
	},

	submitForm: function (e)
	{
		const $form = $(e.target).closest('form'),
			url = $form.attr('action'),
			$dialog = $('div.modal'),
			$buttons = $dialog.find('button.btn-primary');

		$buttons.attr('disabled', 'disabled').addClass('disabled');

		const closeDialog = function (data) {
			$buttons.removeAttr('disabled').removeClass('disabled');
			if (!data.success) return;

			$dialog.modal('hide');
		};

		$.ajax({
			'url': url,
			'type': 'POST',
			'data': $form.serializeArray(),
			'success': closeDialog
		});
	},

	fadeIn: function ()
	{
		if (Common.faderTimeout) clearTimeout(Common.faderTimeout);

		Common.faderTimeout = setTimeout(function(){
			$('div.wait.fade').focus().show()
		}, 1000);
	},

	fadeOut: function ()
	{
		if (Common.faderTimeout) clearTimeout(Common.faderTimeout);

		$('div.wait.fade').hide();
	},

	updateRegionField: function (e)
	{
		var $country = $(this),
			$regions = $("select[data-country-regions='" + $country.val() + "']"),
			$select = $("select[name='region_id']"),
			$input = $("input[name='region_name']"),
			isChosenSelect = $select.next().hasClass('chosen-container');

		if ($regions.length)
		{
			if (isChosenSelect) $select.chosen('destroy');

			var $clone = $regions.clone();

			$input.attr('disabled', true).addClass('hidden');

			$clone
				.attr('data-country-regions', null)
				.attr('name', 'region_id')
				.attr('disabled', false)
				.removeClass('hidden')
				.insertAfter($select);

			$select.remove();
			$clone.chosen();
		}
		else
		{
			if ('dummy' != $select.attr('data-type') && isChosenSelect) $select.chosen('destroy');

			$select.attr('disabled', true).addClass('hidden');

			$input.attr('disabled', false).removeClass('hidden');
		}
	},

	convertMeasurementValue: function (value, type, system)
	{
		if ('height' === type)
		{
			return 'metric' === system
				? (Math.round(value * 2.54 * 100) / 100)
				: (Math.round(value * 0.39370 * 100) / 100);
		}

		if ('weight' === type)
		{
			return 'metric' === system
				? (Math.round(value * 0.453592 * 100) / 100)
				: (Math.round(value * 2.20462 * 100) / 100);
		}

		return value;
	},

	disableSubmitButton: function () {
        $('.disableable_submit_button').click(function(e) {
        	e.preventDefault();
        	const button = e.currentTarget;
            let form = null;
            if (!button.getAttribute('data-form-id')) {
                form = $(button.form);
            } else {
                form = $('#' + button.getAttribute('data-form-id'));
            }
            if(!form[0].checkValidity()){
                form.find('input,select').addClass('touched');
            	return true;
			}
            form.find('input,select').removeClass('touched');
            button.disabled = true;
            if(button.value !== '') {
                form.append($('<input>').attr('type', 'hidden').attr('name', button.name).val(button.value));
            }
            form.submit();
        });
	},

	disableButton: function () {
        $('.disableable_button').click(function(e) {
            e.stopImmediatePropagation();
            e.preventDefault();
        	e.currentTarget.disabled = true;
        });
	},

	bindOptionOpener:  function () {
		$(document).on('click', '[data-option-opener]', function (e) {
			const current = $(e.currentTarget);
			const option = $(current.data('option-opener') + ' option:selected');

			current.attr('href', option.data('url'));
		});
	},

	initRowSelection: () => {
		$(document).change('input[type=checkbox][data-action]', ev => {
			const
				$checkbox = $(ev.target),
				checked = $checkbox.is(':checked');
			switch ($checkbox.data('action')) {
				case 'select-all':
					$('input[type=checkbox][data-action="select-row"]').prop('checked', checked);
					break;
				case 'select-row':
					Common.calculateSelectAll();
					break;
				default:
					break;
			}
			Common.toggleBulkActions();
		});
		$(document).on('submit', 'form.bulk-action', ev => {
			const
				$form = $(ev.target),
				ids = $('input[type=checkbox][data-action="select-row"]:checked').map((_index, checkbox) => $(checkbox).closest('tr[data-id]').data('id')).get();
			if (!ids.length) {
				ev.preventDefault();
			} else {
				$form.find('input[name="ids[]"]').remove();
				ids.forEach(id => {
					$('<input />')
						.attr('type', 'hidden')
						.attr('name', 'ids[]')
						.attr('value', id)
						.appendTo($form);
				});
			}
		});
		Common.calculateSelectAll();
		Common.toggleBulkActions();
	},

	initInlineActions: () => {
		//	Prevent immediate click on row hover.
		$('table.with-inline-actions > tbody > tr > td.buttonset > .btn').css('pointer-events', 'none');
		$('table.with-inline-actions > tbody > tr')
			.on('mouseenter', ev => {
				setTimeout(() => {
					$(ev.target).parent().find('td.buttonset > .btn').css('pointer-events', 'auto');
				}, 300);
			})
			.on('mouseleave', ev => {
				$(ev.target).parent().find('td.buttonset > .btn').css('pointer-events', 'none');
			});
	},

	calculateSelectAll: () => {
		const
			$selectAll = $('input[type=checkbox][data-action="select-all"]'),
			isChecked = !!$('input[type=checkbox][data-action="select-row"]:checked').length,
			isUnchecked = !!$('input[type=checkbox][data-action="select-row"]').not(':checked').length;
		$selectAll
			.prop('indeterminate', isChecked && isUnchecked)
			.prop('checked', isChecked && !isUnchecked);
	},

	toggleBulkActions: () => {
		const isSelectedAny = !!$('input[type=checkbox][data-action="select-row"]:checked').length;
		$('.bulk-actions-buttons').toggleClass('visible', isSelectedAny);
	},

	changeMeasurementSystem: (e) => {
		var measurementSystem = $(e.target).val(),
			$metric = $('.metric'),
			$imperial = $('.imperial'),
			$weight = $("input[name='weight']"),
			$height = $("input[name='height']");

		switch (measurementSystem) {
			case 'metric':
				$metric.removeClass('hidden');
				$imperial.addClass('hidden');
				$weight.val(Common.convertMeasurementValue($weight.val(), 'weight', 'metric'));
				$height.val(Common.convertMeasurementValue($height.val(), 'height', 'metric'));
				break;

			case 'imperial':
				$metric.addClass('hidden');
				$imperial.removeClass('hidden');
				$weight.val(Common.convertMeasurementValue($weight.val(), 'weight', 'imperial'));
				$height.val(Common.convertMeasurementValue($height.val(), 'height', 'imperial'));
				break;
		}
	},

	submitFormAndRedirect: (e) => {
		const $form = $(e.target).closest('form'),
			url = $form.attr('action'),
			$dialog = $('div.modal'),
			$data = $form.serializeArray(),
			$buttons = $dialog.find('button.btn-primary');

		$buttons.attr('disabled', 'disabled').addClass('disabled');

		$data.push({'name': 'redirect', 'value': 1});

		const closeDialog = function (data) {
			$buttons.removeAttr('disabled').removeClass('disabled');
			if (!data.success) return;

			$dialog.modal('hide');

			if (data.redirectTo) window.location.href = data.redirectTo;
		};

		$.ajax({
			'url': url,
			'type': 'POST',
			'data': $data,
			'success': closeDialog
		});
	},

	editSelectedMeal: (e) => {
		var $button = $(e.target).closest('button'),
			day = $button.attr('data-day'),
			tid = $button.attr('data-tid'),
			mid = $button.attr('data-mid'),
			$meal = $("div[data-type='meal'][data-day='" + day + "'][data-tid='" + tid + "']");

		var $select = $("select[name='meal-list']").clone(true, true),
			$span = $meal.find('span.meal');

		if (mid) $select.val(mid);

		$span.replaceWith($select);

		$select
			.attr('name', '')
			.attr('data-day', day)
			.attr('data-tid', tid)
			.removeClass('hidden')
			.chosen();

		var $inputs = $("input[data-day='" + day + "'][data-tid='" + tid + "']"),
			$units = $("span.unit[data-day='" + day + "'][data-tid='" + tid + "']"),
			$quantities = $("span.quantity[data-day='" + day + "'][data-tid='" + tid + "']");

		$units.removeClass('hidden');
		$quantities.addClass('hidden');

		$inputs
			.removeClass('hidden')
			.off('keyup')
			.on('keyup', Common.checkIngredientQuantity);

		$meal
			.find('.text-position-standard')
			.removeClass('text-position-standard')
			.addClass('text-position-aligned');
	},

	webPagesFilter: () => {
		if (0 === $('#web-pages').length) {
			return;
		}

		let tab = localStorage.getItem('web-pages-tab');

		if (null === tab) {
			$('#web-pages ul a:first').tab('show');
		} else {
			$(`#web-pages a[href="${tab}"]`).tab('show');
		}

		$('a[data-toggle="tab"]', '#web-pages').on('shown.bs.tab', (e) => {
			localStorage.setItem('web-pages-tab', e.target.hash);
		})
	},

	generalSettingsPage: () => {
		$('#company_brand_input').on('input', (e) => {
			$('#show-beside-logo-preview .brand-phrase').text(e.currentTarget.value);
		});
	},

	bindFileSizeCheckToUploadInputs: () => {
		$("input[type='file']").bind('change', function () {
			let $input       = $(this),
				maxSize      = $input.attr('data-file-max-size'),
				errorMessage = $input.attr('data-file-max-size-error'),
				totalSize    = 0;

			if (maxSize) for (var i in this.files) {
				totalSize += this.files[i].size;

				if (this.files[i].size > maxSize) {
					break;
				}
			}

			if (totalSize > maxSize) {
				Common.setMessages(
					'danger',
					[errorMessage ? errorMessage : 'The size of file(s) you selected for upload is too big.']
				);

				$input.val('');
				$input.closest('div').find('.file-list').html('');
			}
		});
	},

	updateMinMax: (e) => {
		const unit = $("input[name='multiplier_unit']:checked").val();

		$('span.units').addClass('hidden');
		$('span.unit-' + unit).removeClass('hidden');

		if ($(e.target).prop('readonly')) {
			return;
		}

		const $nutrients = $(e.target).hasClass('min_nutrient') ? $('input.min_nutrient') : $('input.max_nutrient');

		if ('' === $(e.target).val()) {
			$nutrients.prop('readonly', false);
		} else {
			let nonEmptyCount = 0;

			for (let i = 0; i < $nutrients.length; i++) {
				if ('' !== $nutrients.eq(i).val()) {
					nonEmptyCount++;
				}
			}

			if (2 <= nonEmptyCount) {
				for (let i = 0; i < $nutrients.length; i++) {
					if ('' === $nutrients.eq(i).val()) {
						$nutrients.eq(i).prop('readonly', true);
					}
				}
			}
		}

		$('div#nutrients_warning_gram').addClass('hidden');
		$('div#nutrients_warning_percent').addClass('hidden');

		const $minNutrients = $('input.min_nutrient'),
			  $maxNutrients = $('input.max_nutrient'),
			  nutrientsCount = 3;

		for (let i = 0; i < nutrientsCount; i++) {
			let min = parseFloat($minNutrients.eq(i).val()),
				max = parseFloat($maxNutrients.eq(i).val());

			if (!isNaN(min) && !isNaN(max)) {
				if (('gram' === unit || 'gram-per-kg-of-body-weight' === unit) && 0.7 > (max - min)) {
					$('div#nutrients_warning_gram').removeClass('hidden');
				}
				if ('percent' === unit && 15 > (max - min)) {
					$('div#nutrients_warning_percent').removeClass('hidden');
				}
			}
		}
	},

	toleranceWarning: () => {
		$('div#tolerance_warning').addClass('hidden');

		if (5 > $('input#tolerance').val()) {
			$('div#tolerance_warning').removeClass('hidden');
		}
	},

	getPricingPlans: () => {
		$('#product_plans').on('change', function (e) {
			const $plans = $('#pricing_plans');
			const planSelected = $plans.data('selected');

			jQuery.getJSON($(e.target).find('option:checked').data('url'), {}, function (response) {
				$plans.find('option').remove();
				$plans.append($("<option />").val('').text(''));

				response.forEach(function (plan) {
					const option = $("<option />").val(plan.id).text(plan.name);

					if (planSelected === plan.id) {
						option.attr('selected', true);
					}

					$plans.append(option);
				});

				$plans.removeAttr('disabled').trigger('chosen:updated');
			});
		});
	},

	bindDateTimePicker: () => {
		new tempusDominus.TempusDominus(document.getElementById('datetimepicker'), {
			restrictions: {
				minDate: new Date(),
			},
			display: {
				theme: 'dark',
				icons: {
					type: 'icons',
					time: 'fa fa-clock',
					date: 'fa fa-calendar',
					up: 'fa fa-arrow-up',
					down: 'fa fa-arrow-down',
					previous: 'fa fa-chevron-left',
					next: 'fa fa-chevron-right',
					today: 'fa fa-calendar-check',
					clear: 'fa fa-trash',
					close: 'fa fa-xmark'
				},
				sideBySide: true,
			},
			localization: {
				locale: 'en'
			}
		});
	}
};

window.Common = Common;

Common.showConfirmation = showConfirmation;
